import React, { useState } from "react";
import PropTypes from "prop-types";
import { navigate } from "gatsby";
import Layout from "../components/Templates/Layout";
import Meta from "../utils/Meta";
import Banner from "../components/Hero/Banner";
import Title from "../components/Title/Title";
import Sections from "../components/Sections/Sections";
import CardContact from "../components/Cards/CardContact";
import Link from "../components/Global/Link";
import {
  Input,
  Email,
  Textarea,
  Checkboxes,
  Select,
} from "../components/Global/Forms";

import { useFormik } from "formik";
import * as Yup from "yup";

// ====

const Contact = (props) => {
  const { pageContext, blok } = props;
  let doc;
  if (pageContext) {
    doc = JSON.parse(pageContext.story.content);
  } else {
    doc = blok;
  }
  const openGraph = {
    type: "website",
    title: doc.title,
    description: doc.body,
    image: doc.image,
  };

  const [attempt, setAttempt] = useState(false);

  const pageUrl =
    typeof window !== "undefined" ? window.location.href : "No URL";

  const formik = useFormik({
    initialValues: {
      enquiryType: "",
      yourName: "",
      yourEmail: "",
      yourMessage: "",
      formLocation: pageUrl,
    },
    validationSchema: Yup.object({
      enquiryType: Yup.string().required("Please select a recipient"),
      yourName: Yup.string().required("Please tell us your name"),
      yourEmail: Yup.string()
        .email("This looks like an invalid email address")
        .required("Your email address is required"),
      yourMessage: Yup.string().required("Please type a message"),
    }),
    onSubmit: async (values) => {
      // alert(JSON.stringify(values));

      await fetch("/.netlify/functions/sendgrid", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          enquiry_type: values.enquiryType,
          user_name: values.yourName,
          user_email: values.yourEmail,
          user_message: values.yourMessage,
          form_location: values.formLocation,
        }),
      });
      navigate("/thanks/");
    },
  });

  return (
    <Layout>
      <Meta openGraph={openGraph} meta={doc.meta} />
      <Banner
        title={doc.hero_title}
        description={doc.hero_body}
        image={doc.hero_image}
      />
      <section className="pt-5">
        <div className="container">
          {doc.title && <Title title={doc.title} description={doc.body} />}
          <div className="row gy-4 justify-content-start d-none">
            {doc.items.map((node, index) => {
              return (
                <div className="col-12 col-md-6">
                  <CardContact item={node} />
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="py-3 py-md-5 brand-background-grey">
        <div className="container">
          <form
            className="row justify-content-center"
            name="contact"
            onSubmit={formik.handleSubmit}
          >
            <input
              type="hidden"
              id="formLocation"
              value={pageUrl ? pageUrl : "Location unknown"}
            />

            <div className="col-12">
              <div className="m-0 p-md-5 p-2 brand-radius brand-shadow brand-background-green brand-text-white">
                <div className="row justify-content-center mb-3">
                  <label for="enquiryType" className="col-sm-2 col-form-label">
                    Enquiry Type
                  </label>
                  <div className="col-sm-10">
                    <select
                      className={`form-select form-control brand-input ${
                        formik.touched.enquiryType && formik.errors.enquiryType
                          ? "brand-input-error"
                          : ""
                      }`}
                      aria-label="Enquiry Type"
                      id="enquiryType"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option selected hidden disabled>
                        Please select...
                      </option>

                      <option value="support@mergegames.com">
                        Customer Support
                      </option>

                      <option value="techsupport@mergegames.com">
                        Tech Support
                      </option>

                      <option value="marketing@mergegames.com">
                        Marketing
                      </option>

                      <option value="press@mergegames.com">Press</option>

                      <option value="bizdev@mergegames.com">Developers</option>
                    </select>
                    {formik.touched.enquiryType && formik.errors.enquiryType ? (
                      <div className="small brand-background-pink brand-text-white px-2 mx-3 pb-1 rounded-bottom">
                        {formik.errors.enquiryType}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row justify-content-center mb-3">
                  <label for="yourName" className="col-sm-2 col-form-label">
                    Your name
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className={`form-control brand-input ${
                        formik.touched.yourName && formik.errors.yourName
                          ? "brand-input-error"
                          : ""
                      }`}
                      id="yourName"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.yourName}
                    />
                    {formik.touched.yourName && formik.errors.yourName ? (
                      <div className="small brand-background-pink brand-text-white px-2 mx-3 pb-1 rounded-bottom">
                        {formik.errors.yourName}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row justify-content-center mb-3">
                  <label for="yourEmail" className="col-sm-2 col-form-label">
                    Email Address
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="email"
                      className={`form-control brand-input ${
                        formik.touched.yourEmail && formik.errors.yourEmail
                          ? "brand-input-error"
                          : ""
                      }`}
                      id="yourEmail"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.yourEmail}
                    />
                    {formik.touched.yourEmail && formik.errors.yourEmail ? (
                      <div className="small brand-background-pink brand-text-white px-2 mx-3 pb-1 rounded-bottom">
                        {formik.errors.yourEmail}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="row justify-content-center mb-3">
                  <label for="yourMessage" className="col-sm-2 col-form-label">
                    Message
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      className={`form-control brand-input ${
                        formik.touched.yourMessage && formik.errors.yourMessage
                          ? "brand-input-error"
                          : ""
                      }`}
                      id="yourMessage"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.yourMessage}
                    />
                    {formik.touched.yourMessage && formik.errors.yourMessage ? (
                      <div className="small brand-background-pink brand-text-white px-2 mx-3 pb-1 rounded-bottom">
                        {formik.errors.yourMessage}
                      </div>
                    ) : null}
                  </div>
                </div>

                {attempt === true &&
                (formik.errors.yourName ||
                  formik.errors.yourEmail ||
                  formik.errors.yourMessage ||
                  formik.errors.enquiryType) ? (
                  <div className="row justify-content-center">
                    <div className="col-12">
                      There are items that require your attention before the
                      form can be sent
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <div className="row justify-content-end">
                  <div className="col-auto">
                    <Link
                      button="real"
                      icon="paper-plane"
                      colour="white"
                      onClick={() => setAttempt(true)}
                    >
                      Submit
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
      <Sections items={doc.sections} />
    </Layout>
  );
};

export default Contact;

Contact.propTypes = {
  pageContext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Contact.defaultProps = {
  pageContext: null,
  blok: null,
};
